import "./style.css";

interface Props {
	/** Diameter in px. Omit to let CSS size it (default 40px). */
	size?: number;
	/** Minimum height of the area the spinner is centred in. */
	minHeight?: number | string;
}

// KWSA-42: shown wherever the layout depends on session.location, which is not
// known until the session has loaded — the top bar logo, the general info bar
// and the data tables. Rendering a placeholder there would mean guessing.
const Spinner = ({ size, minHeight }: Props): JSX.Element => (
	<div className="fs-spinner-wrapper" style={minHeight ? { minHeight } : undefined}>
		<div
			className="fs-spinner"
			style={
				size
					? { width: size, height: size, borderWidth: Math.max(2, Math.round(size / 12)) }
					: undefined
			}
			role="status"
			aria-label="Loading"
		/>
	</div>
);

export default Spinner;
